import React, { useState, useEffect } from 'react';
import { useAuth } from '../../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { FiMessageCircle, FiBarChart2, FiShield, FiZap } from 'react-icons/fi';
import api from '../../utils/api';

export default function LoginPage() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const { login } = useAuth();
  const navigate = useNavigate();

  const [branding, setBranding] = useState(null);

  useEffect(() => {
    api.get('/auth/branding').then(({ data }) => setBranding(data)).catch(() => {});
  }, []);

  const featureIcons = [<FiMessageCircle />, <FiBarChart2 />, <FiShield />, <FiZap />];

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const data = await login(username, password);
      toast.success('Welcome back!');
      navigate(data.user.role === 'admin' ? '/admin/dashboard' : '/user/dashboard');
    } catch (err) {
      setError(err.response?.data?.message || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      {/* Left Brand Panel */}
      <div className="login-brand-panel">
        <div className="login-shape login-shape-1" />
        <div className="login-shape login-shape-2" />
        <div className="login-shape login-shape-3" />
        <div className="login-brand-content">
          <img src={branding?.logoUrl || '/Affixcenter_OG_Fulllogo.png'} alt="Logo" style={{ width: 300, height: 100, borderRadius: 16, objectFit: 'contain', marginBottom: 12, background: 'white' }} />
          <h2>{branding?.appName || 'Affix Digital Setu'}</h2>
          <p style={{ background: 'linear-gradient(135deg, #7ea52e, #b7d083)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', backgroundClip: 'text'  }}>{branding?.tagline || '"From Brief to Execution, Turning Ideas into Reality."'}</p>
          <div className="login-brand-features">
            {(branding?.features || [
              'Multi-channel broadcast management',
              'Real-time delivery analytics',
              'Secure data with role-based access',
              'Smart scheduling & automation'
            ]).map((feat, i) => (
              <div className="login-brand-feature" key={i}>
                <div className="login-brand-feature-icon">{featureIcons[i % featureIcons.length]}</div>
                <span>{feat}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Right Form Panel */}
      <div className="login-form-panel">
        <div className="login-container">
          <div className="login-header">
            <div className="login-welcome-tag">Welcome back</div>
            <h1>Sign in to your account</h1>
            <p>Enter your credentials to access the dashboard</p>
          </div>

          {error && <div className="alert alert-error">{error}</div>}

          <form onSubmit={handleSubmit} className="login-form">
            <div className="form-group">
              <label className="form-label">Username</label>
              <input type="text" className="form-input" placeholder="Enter your username"
                value={username} onChange={e => setUsername(e.target.value)} required autoFocus />
            </div>
            <div className="form-group">
              <label className="form-label">Password</label>
              <input type="password" className="form-input" placeholder="Enter your password"
                value={password} onChange={e => setPassword(e.target.value)} required autoComplete="current-password" />
            </div>
            <button type="submit" className="login-btn" disabled={loading}>
              {loading ? 'Signing in...' : 'Sign In'}
            </button>
          </form>

          <div className="login-footer-link">
            <a href="/superadmin/login">Super Admin Access →</a>
          </div>
        </div>
      </div>
    </div>
  );
}
